import { Menus } from "../../../components/Menu/idex";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../../Api/ApiService";
import {
  Text,
  Button,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  ModalContent,
  FormControl,
  FormLabel,
  Switch,
  useToast,
  Icon,
  InputRightAddon,
  FormHelperText,
  FormErrorMessage,
  InputGroup,
  Spinner,
  HStack,
} from "@chakra-ui/react";
import { Container, Pesquisa, StyledInputGroup } from "./styles";
import { AxiosError } from "axios";
import { useParams } from "react-router-dom";
import { getUser } from "../../../context/token";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Animal } from "../../../components/CardAnimal";
import { ModalAnimal } from "../../../components/ModalCadEdiAnimal";

type AnimalResponse = {
  animal_id: string;
  nome: string;
  foto: {
    type: string;
    data: Buffer;
  };
  tipo: string;
  raca: string;
  sexo: string;
  descicao: string;
  disponivel: boolean;
  castrado: boolean;
};

type IPropsAnimal = {
  status?: number;
};



const Animais = ({ status }: IPropsAnimal) => {
  const { tipo_animais } = useParams();
  const [valueFilter, setValueFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [animalList, setAnimalList] = useState<AnimalResponse[]>([]);
  const [animalListOrigin, setAnimalListOrigin] = useState<AnimalResponse[]>(
    []
  );
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const { role } = getUser();
  const toast = useToast();
  const [isModal, setIsmodal] = useState(false)
  const [isLoand, setIsLoand] = useState(true);

  

  async function getAnimais() {
    try {
      setIsLoand(true);
      let aux: AnimalResponse[] = [];
      const result = await api.get(
        `/animais?token=${process.env.REACT_APP_TOKEN_API}`
      );
      result.data.map((animal: any) => aux.push(animal.data));

      switch (tipo_animais) {
        case "1": {
          setIsLoand(true);
          aux = aux.filter((animal) => {
            if (animal.disponivel && animal.tipo.toUpperCase() === "CACHORRO") {
              return animal;
            }
          });
          setIsLoand(false);
          break;
        }
        case "2": {
          setIsLoand(true);
          aux = aux.filter((animal) => {
            if (animal.disponivel && animal.tipo.toUpperCase() === "GATO") {
              return animal;
            }
          });
          setIsLoand(false);
          break;
        }
      }

      setAnimalList(aux);
      setAnimalListOrigin(aux);
      setIsLoand(false);
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function filter(option: string) {
    switch (option) {
      case "1": {
        const result = animalListOrigin.filter(
          (animal) => animal.disponivel == false
        );
        setAnimalList(result);
        break;
      }
      case "2": {
        const result = animalListOrigin.filter(
          (animal) => animal.disponivel == true
        );
        setAnimalList(result);
        break;
      }
      case "3": {
        const result = animalListOrigin.filter(
          (animal) => animal.sexo.toUpperCase() === "MACHO"
        );
        setAnimalList(result);
        break;
      }
      case "4": {
        const result = animalListOrigin.filter(
          (animal) => animal.sexo.toUpperCase() === "FÊMEA"
        );
        setAnimalList(result);
        break;
      }
      case "5": {
        const result = animalListOrigin.filter(
          (animal) => animal.castrado == true
        );
        setAnimalList(result);
        break;
      }
      case "6": {
        const result = animalListOrigin.filter(
          (animal) => animal.castrado === false
        );
        setAnimalList(result);
        break;
      }
      default: {
        getAnimais();
      }
    }
  }

  async function search(term: string) {
    if (term != "") {
      const result = animalList.filter((animal) => {
        if (
          animal.raca.toUpperCase().includes(term.toUpperCase()) ||
          animal.tipo.toUpperCase().includes(term.toUpperCase()) ||
          animal.nome.toUpperCase().includes(term.toUpperCase())
        ) {
          return animal;
        }
      });
      setAnimalList(result);
    } else {
      getAnimais();
    }
  }

  useEffect(() => {
    getAnimais();
  }, []);

  useEffect(() => {
    filter(valueFilter);
  }, [valueFilter]);

  useEffect(() => {
    search(searchValue);
  }, [searchValue]);

  const handleOpenModal = () => {
    setIsmodal(true);
  };

  const handleCloseModal = () => {
    setIsmodal(false);
  };

  return (
    <>
      <Menus />

      {role == "admin" ? (
        <Pesquisa>
          <Select
            mr={5}
            mb={5}
            placeholder="Selecione uma opção"
            className="input-select"
            size="md"
            value={valueFilter}
            width={"210px"}
            onChange={(e) => setValueFilter(e.target.value)}
          >
            <option value="1">Adotados</option>
            <option value="2">Disponíveis para adoção</option>
            <option value="3">Machos</option>
            <option value="4">Fêmeas</option>
            <option value="5">Animais castrados</option>
            <option value="6">Animais não castrados</option>
          </Select>

          <InputGroup size="md" mr={5} mb={5} className="input-pesquisa">
            <Input
              type={"text"}
              placeholder="Pesquise por tipo ou raça"
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <InputRightAddon>
              <button onClick={() => search(searchValue)}>
                <MagnifyingGlass size={26} color="#828282" />
              </button>
            </InputRightAddon>
          </InputGroup>

          <div>
            <Button
              className="bnt-cadastro"
              mb={5}
              onClick={() => {
                setIsmodal(true)
              }}
            >
              Cadastrar animal
            </Button>
          </div>
          <ModalAnimal onClose={handleCloseModal} isOpen={isModal} modo={"cadastro"} />
        </Pesquisa>
      ) : (
        <></>
      )}

      <Container>
        {isLoand == true ? (
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="#b8384a"
            size="xl"
            mt={20}
          />
        ) : animalList.length > 0 ? (
          animalList.map((pet) => (
            <Animal
              animal_id={pet.animal_id}
              tipo_animal={pet.tipo}
              nome={pet.nome}
              raca={pet.raca}
              foto={pet.foto.data}
              sexo={pet.sexo}
              descricao={pet.descicao}
              disponibilidade={pet.disponivel}
              castrado={pet.castrado}
            />
          ))
        ) : (
          <Text pt={20} fontSize={20}>
            Nenhum animal disponível no momento
          </Text>
        )}
      </Container>
    </>
  );
};

export { Animais };
